<div class="container">

    <form class="col-12 col-md-8 offset-md-2  col-lg-6 offset-lg-3 p-4 mt-3 mb-4">
        <h3 class="mb-4 text-center">{{'Inscription' | translate}}</h3>



        <div class="alert alert-success" role="alert" *ngIf="feedback.success">
            {{feedback.success}}
        </div>

        <div class="form-group">
            <label for="Name" class="col-form-label">{{'Nom Complet' | translate}}:</label>
            <input class="form-control form-control-danger" type="text" [(ngModel)]="user.name" name="name">
            <div *ngIf="feedback.message1" class="form-control-feedback">{{feedback.message1}}</div>
        </div>

        <div class="form-group">
            <label for="Company" class="col-form-label">{{'Entreprise' | translate}}:</label>
            <input class="form-control form-control-danger" type="text" [(ngModel)]="user.company" name="company">
            <div *ngIf="feedback.message5" class="form-control-feedback">{{feedback.message5}}</div>
        </div>

        <div class="form-group">
            <label for="mail" class="col-form-label">{{'Email' | translate}}:</label>
            <input type="mail" (keyup)="removeSpace($event)" class="form-control" [(ngModel)]="user.mail" name="mail">
            <div *ngIf="feedback.message3" class="form-control-feedback">{{feedback.message3}}</div>
        </div>

        <div class="form-group">
            <label for="password" class="col-form-label">{{'Mot de passe' | translate}}:</label>
            <div class="input-group mb-3">
                <input type="{{(showPassword[0]) ? 'text' : 'password'}}" class="form-control password" [(ngModel)]="user.password" name="password">
                <div class="input-group-append">
                    <span class="input-group-text bg-white cursor-pointer" (click)="showPassword[0] = !showPassword[0]">
                        <i class="far fa-eye" *ngIf="!showPassword[0]"></i>
                        <i class="far fa-eye-slash" *ngIf="showPassword[0]"></i>
                    </span>
                </div>
            </div>
            <password-checker *ngIf="user['password']" [password]="user['password']" (changeValidity)="validPassword = $event"></password-checker>
            <div *ngIf="feedback.message2" class="form-control-feedback">{{feedback.message2}}</div>
        </div>

        <div class="form-group">
            <label for="password2" class="col-form-label">{{'Retapez le mot de passe' | translate}}:</label>
            <div class="input-group mb-3">
                <input type="{{(showPassword[1]) ? 'text' : 'password'}}" class="form-control password" [(ngModel)]="user.password2" name="password2">
                <div class="input-group-append">
                    <span class="input-group-text bg-white cursor-pointer" (click)="showPassword[1] = !showPassword[1]">
                        <i class="far fa-eye" *ngIf="!showPassword[1]"></i>
                        <i class="far fa-eye-slash" *ngIf="showPassword[1]"></i>
                    </span>
                </div>
            </div>
            <div *ngIf="feedback.message21" class="form-control-feedback">{{feedback.message21}}</div>
        </div>

        <div class="form-group">
            <label for="phone" class="col-form-label">{{'Téléphone' | translate}}:</label>
            <input type="type" class="form-control" [(ngModel)]="user.phone" name="phone">
            <div *ngIf="feedback.message4" class="form-control-feedback">{{feedback.message4}}</div>
        </div>

        <div class="form-group">
            <label for="activity" class="col-form-label">{{'Secteur d’activité' | translate}}:</label>
            <select class="custom-select" [(ngModel)]="user.activity" name="activity" id="activity">
                <option value="0" disabled>{{'-- Sélectionner un secteur d’activité --' | translate}}</option>
                <option *ngFor="let activity of activitys" value="{{activity.id}}">{{ activity[language.i18nGetAttr('name')] }}</option>
            </select>
            <div *ngIf="feedback.message10" class="form-control-feedback">{{feedback.message10}}</div>
        </div>

        <div class="form-group">
            <label for="function" class="col-form-label">{{'Fonction' | translate}}:</label>
            <select class="custom-select" [(ngModel)]="user.companyFunction" name="function" id="function">
                <option value="0" disabled>{{'-- Sélectionner une fonction --' | translate}}</option>
                <option *ngFor="let function of functions" value="{{function.name}}">{{function.name}}</option>
            </select>
            <div *ngIf="feedback.message17" class="form-control-feedback">{{feedback.message17}}</div>
        </div>

        <div class="form-group">
            <label for="preferredLanguage" class="col-form-label">{{'Langue' | translate}}:</label>
            <select class="custom-select" [(ngModel)]="user.preferredLanguage" name="preferredLanguage" id="preferredLanguage">
                <option value="fr">{{'Français' | translate}}</option>
                <option value="en" selected>{{'Anglais' | translate}}</option>
            </select>
        </div>
        <div>
            <div class="form-group">
                <label for="country" class="col-form-label">{{'Pays' | translate}}:</label>
                <select class="custom-select" [(ngModel)]="user.country" name="userCountry" (change)="refreshResellers()">
                    <option value="" disabled>{{'Please choose...' | translate}}</option>
                    <option [value]="c['code']" *ngFor="let c of allCountries">{{c['name']}}</option>
                </select>
                <div *ngIf="feedback.message6" class="form-control-feedback">{{feedback.message6}}</div>
            </div>

            <div class="form-group">
                <label for="known" class="col-form-label">{{'Comment nous avez-vous connu?' | translate}}:</label>

                <select class="custom-select" [(ngModel)]="user.known" name="known" id="known">
                    <option value="0" disabled>{{"-- Sélectionnez un moyen --" | translate}} </option>
                    <option *ngFor="let known of knowns" value="{{known.id}}">{{ known[language.i18nGetAttr('name')] }}</option>

                </select>
                <div *ngIf="feedback.message11" class="form-control-feedback">{{feedback.message11}}</div>
            </div>
        </div>



        <div class="form-group">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="checkNewsletter" name="newsletter" [(ngModel)]="user.newsletter">
                <label class="custom-control-label" for="checkNewsletter">{{'M\'inscrire à la newsletter' | translate}}</label>
            </div>
        </div>

        <div class="form-group">
            <re-captcha #captcha *ngIf="captchaDisplay" siteKey="6LcPqFUUAAAAAG84T0vZSmcSa_0dQKMjhVQBrWDs"></re-captcha>
        </div>

        <div class="form-group mb-0 mt-4">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="checkLegal" name="legalChecked" [(ngModel)]="legalChecked">
                <label class="custom-control-label mr-1" for="checkLegal">{{'J\'ai lu et j’accepte' | translate}}</label> <label><a [routerLink]="language.navigateAccordingToLang(['/legal'])" target="_blank" title="general conditions of sale">{{'les conditions générales de vente' | translate}}</a></label>
            </div>
            <div *ngIf="feedback.message7" class="form-control-feedback">{{feedback.message7}}</div>
        </div>

        <div class="d-flex justify-content-center align-items-center mt-4">
            <div class="col-10 col-xl-8 position-relative">
                <button type="button" (click)="register()" class="btn btn-action btn-register rounded-full btn-block" data-toggle="modal" data-target="#reg">{{'M\'inscrire' | translate}}</button>
                <div class="register-lock" data-toggle="tooltip" data-placement="right" title="{{'Afin de garantir la sécurité des données de votre compte, nous utilisons le protocole SSL' | translate}}(Secure Sockets Layer)">
                    <i class="fas fa-unlock-alt fa-lg text-warning"></i>
                </div>
            </div>
        </div>

        <p class="text-center mt-1">
            <a [routerLink]="language.navigateAccordingToLang(['/'])" (click)="appService.showPopup()" class="mt-2" title="login">{{"J'ai déja un compte" | translate}}</a>
        </p>



    </form>
</div>

<app-iframe-gratitude *ngIf="showGratitude" iframeurl="/gratitude/register.html" (iframeLoaded)="iframeLoaded()"></app-iframe-gratitude>
